"use client"
import React, {useState} from 'react';
import {Button} from "@/components/ui/button";
import {CartItem} from "@/store/shipping-cart/cart-store";
import {useCart} from "@/store/shipping-cart/useCart";
import {Loader, MinusIcon, PlusIcon, Trash2} from "lucide-react";
import toast from "react-hot-toast";
import {SingleProductEnum} from "@/constants/commerce-enum";
import {DataLayerFactory} from "@/components/google-tag-manager/DataLayerFactory";

interface AddToCartButtonProps {
    product: CartItem
}


function AddToBasketButton({product}: AddToCartButtonProps) {
    const {addToCart, items, removeFromCart, updateItemQuantity} = useCart()
    const [isAdding, setIsAdding] = useState(false)


    const handleAddToCart = async () => {
        setIsAdding(true)
        addToCart(product)
        setIsAdding(false)
        const addToCartDataLayer = DataLayerFactory.make('add_to_cart', 0, '', product.product_item_id, 1 , '' );
        addToCartDataLayer.pushToDataLayer();
        toast.success(SingleProductEnum.addToBasketSuccessfully, {
            position: "top-center"
        })
    }


    const handleUpdateQuantity = async (unique_id: string | null, quantity: number) => {
        const limit = Math.min(product?.max_basket_limit, product?.min_total_qty_and_max_basket_qty);

        if (!!quantity && quantity > limit) {
            toast.error(`بیشتراز ${limit} عدد نمیتوانید به سبد خرید خود اضافه کنید`, {
                position: "top-center",
            });
            return;
        }
        updateItemQuantity(unique_id, quantity)
    }

    const handleRemoveItem = async (unique_id: string | null) => {
        removeFromCart(unique_id)
    }

    const filteredItem: CartItem | undefined = items?.find(item => item?.unique_id === product?.unique_id)

    return (
        <>  {!!filteredItem && filteredItem?.quantity > 0 ? (<div
            className="w-full justify-center items-center px-2 rounded-2xl bg-white border-orange-primary border-2 h-12 flex flex-wrap ">
            <div className="w-[145px] flex items-center justify-between ">
                <div className={"text-gray-400"}>
                    {SingleProductEnum.count}:
                </div>
                <Button variant={"outline"}
                        onClick={() => handleUpdateQuantity(filteredItem?.unique_id, filteredItem?.quantity + 1)}
                        className="p-1 w-7 h-7  m-0 border-0">
                    <PlusIcon className={"w-6 h-6 "}/>
                </Button>

                <div
                    className="w-6 flex items-center justify-center h-6 text-lg text-orange-primary">
                    {filteredItem?.quantity?.toLocaleString("fa")}
                </div>


                {
                    filteredItem?.quantity > 1 ? (
                        <Button
                            onClick={() => handleUpdateQuantity(filteredItem?.unique_id, filteredItem?.quantity - 1)}
                            variant={"outline"} className="p-1 w-7 h-7  m-0 border-0">
                            <MinusIcon className={"w-6 h-6 "}/>
                        </Button>
                    ) : (
                        <Button
                            onClick={() => handleRemoveItem(filteredItem?.unique_id)}
                            variant={"outline"} className="p-1 w-7 h-7  m-0 border-0">
                            <Trash2 className={"w-6 h-6 "}/>
                        </Button>
                    )
                }
            </div>
        </div>) : (
            <Button
                onClick={handleAddToCart}
                disabled={isAdding}
                className="w-full h-[48px] rounded-2xl  bg-orange-primary active:scale-95 transition-all duration-200">
                {isAdding ? <Loader className="animate-spin"/> : SingleProductEnum.addToCart}
            </Button>
        )}

        </>

    );
}

export default AddToBasketButton;